import Cookies from 'universal-cookie';
import {getProject} from '../_shared/GWTBridge/invoke/genPage';
import {
    countriesSymbolMap,
    internalProjecsType,
    langNumToTitleMap,
    timezonesCountryMap
} from './consts';
import {enGB, enUS, he} from 'date-fns/locale';

const cookies = new Cookies();
const cookieLang: string = cookies.get('Language');

export function getLocale() {
    const lang = getLang();
    return isRTL() ? 'he' : lang !== '3' ? 'en-gb' : 'en';
}

export const isAmericanLocale = () => {
    return getLocale() === 'en';
};

export function getLang() {
    return cookieLang;
}

export function isRTL() {
    const lang = getLang();
    return lang === '1' || lang === '29';
}

export function isEnglish() {
    const lang = getLang();
    return lang === '2' || lang === '3';
}

export function getLangTitle() {
    const lang = getLang();
    return langNumToTitleMap[lang] || lang;
}

export function getCountry() {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    if (timezone === '' || !timezone) {
        return null;
    }

    const _country = timezonesCountryMap[timezone]?.c?.[0];
    return countriesSymbolMap[_country];
}

export function getProjType() {
    const project = getProject();
    return internalProjecsType.includes(project) ? 'internal' : 'regular';
}

export function convertToFnsFormat(format: string) {
    return format.replace(/D/g, 'd').replace(/Y/g, 'y');
}

export function getFnsLocale(lang: string) {
    switch (lang) {
        case '1':
            return he;
        case '2':
            return enGB;
        default:
            return enUS;
    }
}
